import React from "react";
import { InputField } from "../../../../../components/controls/InputField";

export default function GuardrailGenerator({
  updatedGuardrail,
  setUpdatedGuardrail,
}) {
  const handleFieldChanged = (val) => {
    const updated = { ...updatedGuardrail, promptContent: val };
    setUpdatedGuardrail(updated);
  };
  // if (disallowedTopics.length > 0) {
  //   return (
  //     <ul className="disallowed-topics-list">
  //       {disallowedTopics.map((item, index) => (
  //         <li key={index}>
  //           {item}{" "}
  //           {(isMasterPrompt || organization?.value?.length > 0) && (
  //             <button onClick={() => handleRemove(item)}>
  //               <MinusIcon className="minus-icon" />
  //             </button>
  //           )}
  //         </li>
  //       ))}
  //     </ul>
  //   );
  // }

  return (
    <>
      <InputField
        forceValidate={false}
        value={updatedGuardrail?.promptContent || ""}
        onChange={(value) => handleFieldChanged(value)}
        maxLength={8000}
        groupId={"GUARDRAIL"}
        subTitle={
          "Provide the content of the system prompt preferably in Markdown format."
        }
        type="textarea"
        fieldName="promptContent"
        validationName="Guardrail_Content"
      />
    </>
  );
}
